// The markdown constructs that neither MarkdownEditor nor MarkdownViewer supports. Both turn
// them off in their parsers, so that text nobody meant as markdown is shown as the text it is:
// HTML stays HTML on the screen, an indented line is not read as a code block, and ![...](...),
// [...](...) and <https://...> stay the text they are, since we support no images and no links.
//
// The editor has a second reason to turn them off: it loads nothing at all - silently - when the
// text contains a markdown construct that none of its plugins can edit.
export const unsupportedMarkdownConstructs = [
  "htmlFlow",
  "htmlText",
  "codeIndented",
  "codeFenced",
  "labelStartImage",
  "labelStartLink",
  "autolink",
];
